import React from 'react';
import { motion } from 'framer-motion';
import type { ServiceCardProps } from './types';

const ServiceCard: React.FC<ServiceCardProps> = ({ service, onSelect, buttonText: _buttonText = 'Book Now' }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      onClick={() => onSelect(service)}
      className="rounded-lg overflow-hidden hover:shadow-md transition-shadow border border-gray-200 dark:border-gray-600 hover:border-primary relative h-96 cursor-pointer"
    >
      {/* Full card background image */}
      <img 
        src={service.image} 
        alt={service.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay only at bottom for content */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
      
      {/* Content overlay */}
      <div className="relative h-full flex flex-col">
        {/* Content area with light black background */}
        <div className="flex-1 flex flex-col justify-end">
          <div className="bg-black/30 p-3 pb-14">
            <div className="flex justify-between items-center">
              <h3 className="text-base font-bold text-white mb-1 line-clamp-1 flex-1 font-['Playfair_Display']">
                {service.name}
              </h3>
              <span className="text-white text-xs ml-2 font-['Inter']">
                {service.duration} min
              </span>
            </div>
          </div>
        </div>
        
        {/* Button fixed at bottom with price */}
        <div className="absolute bottom-0 left-0 right-0">
          <button
            onClick={() => onSelect(service)}
            className="w-full py-3 text-base bg-primary text-white hover:bg-primary/90 transition-colors font-bold flex items-center justify-between px-4 tracking-wide"
          >
            <span>Book Now</span>
            <span className="text-lg font-bold">{service.price}</span>
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
